const TEST_MODE = true; // switch between Testing and Production

export const environment = {
  production: false,
  VERSION: require('../../package.json').version,
  packageDate: '20261103',
  testMode: TEST_MODE, // toggle this true for local machine dev
  PROD_API_SERVER_ADDRESS: 'https://scaletech-west-api.azurewebsites.net',
  TESTING_API_SERVER_ADDRESS: 'https://scaletech-west-api-testing.azurewebsites.net',
  appInsights: {
    instrumentationKey: '30f125c8-eaf1-4685-b550-b44a22205be8'
  },
  FORTE_SCRIPT_URL: TEST_MODE ? "https://sandbox.forte.net/checkout/v2/js" : 'https://checkout.forte.net/v2/js',
  MANIFEST_LENGTH_OVERRIDE: 90,
  useDebugSerialConnection: false,
  CLOVER_APP_MARKET_LINK: TEST_MODE ? 'https://sandbox.dev.clover.com/appmarket/apps/E9SK3MHQ0XMPP' : 'https://www.clover.com/appmarket/apps/HD9639SRBJJGY'
};
